<template>
    <div class="table-striped">
        <div class="table-box" v-if="!empty && loadStatusTbl">
            <md-table md-card v-model="items" :table-header-color="tableHeaderColor">
                <md-table-row slot="md-table-row" slot-scope="{ item }" md-dense>
                    <md-table-cell md-label="Название">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Тип Кассы">{{ item.type.name }}</md-table-cell>
                    <md-table-cell md-label="QR mvizaID">{{ item.meta.mviza.id }}</md-table-cell>
                    <md-table-cell md-label="QR Mviza merchantName">{{ item.meta.mviza.name }}</md-table-cell>
                    <md-table-cell md-label="QR Mviza category ID">{{ item.meta.mviza.category_id }}</md-table-cell>
                    <md-table-cell md-label="QR Mviza terminal ID">{{ item.meta.mviza.terminal_id }}</md-table-cell>
                    <md-table-cell>
                        <md-avatar>
                            <md-tooltip>Редактировать</md-tooltip>
                            <md-icon @click.native="editCasbox(item.id, item.company_id)" class="md-icon-font-green md-theme-default pointer">edit</md-icon>
                        </md-avatar>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <div class="pagination-block">
                <paginate
                :page-count="this.getCountPage()"
                :click-handler="changePagination"
                :prev-text="''"
                :next-text="''"
                :value="this.getCurrentPage()"
                :container-class="'pagination pagination-no-border pagination-success pagination-primary'">
                </paginate>
            </div>
        </div>

        <div class="loading-overlay" v-if="!loadStatusTbl">
            <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="md-empty-state" v-if="empty">
            <h1>Записей не найдено</h1>
        </div>
    </div>
</template>
<script>
import HttpClient from '@/api/calls'

export default {
  name: 'CashTable',
  props: {
    tableHeaderColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: [],
      items: [],
      city: [],
      meta: [],
      empty: true,
      pagination: {
        current_page: 0,
        count_page: 0
      },
      loadStatusTbl: false,
      shopId: false,
      companyId: false,
      currentSort: 'name',
      currentSortOrder: 'asc',
      currentSortOld: 'name',
      currentSortOrderOld: 'asc'
    }
  },
  methods: {
    getCashByShop () {
      this.shopId = this.$route.params.id
      if (this.shopId) {
        return HttpClient.httpGet(['cash.listByShop', this.shopId], this.prepareCashFilters())
      }
      return []
    },
    parseResponse (cashboxData) {
      if (cashboxData.meta) {
        this.meta = cashboxData.meta
        this.setCurrentPage(this.meta.pagination['current_page'])
        this.setCountPage(this.meta.pagination['total_pages'])
      }
      if (cashboxData.data && cashboxData.data.length !== 0) {
        this.items = cashboxData.data
        this.empty = false
      } else {
        this.items = []
        this.empty = true
      }
      this.loadStatusTbl = true
    },
    changePagination (pageNum) {
      if (this.getCurrentPage() === pageNum) {
        return
      }
      this.setCurrentPage(pageNum)
      this.refreshData()
    },
    refreshData () {
      const $this = this
      this.getListShop().then(function (response) {
        $this.parseResponse(response)
      })
    },
    prepareCashFilters () {
      let params = {}
      params['filter'] = this.$store.state.filtersCash
      params['include'] = 'meta.mviza'
      return params
    },
    editCasbox (id, shopId) {
      this.$store.state.editId = id
      this.$store.state.shopId = shopId
      this.$emit('editCasbox')
    },
    customSort (value) {
      if (this.currentSort === this.currentSortOld && this.currentSortOrder === this.currentSortOrderOld) {
        return value
      }
      this.currentSortOld = this.currentSort
      this.currentSortOrderOld = this.currentSortOrder
      this.refreshData()
      return value
    },
    getCurrentPage () {
      return this.$store.state.pagination.current_page
    },
    setCurrentPage (currentPage) {
      this.$store.state.pagination.current_page = currentPage
    },
    getCountPage () {
      return this.$store.state.pagination.count_page
    },
    setCountPage (countPage) {
      this.$store.state.pagination.count_page = countPage
    }
  },
  async created () {
    const $this = this
    let data = await Promise.resolve($this.getCashByShop())
    if (data) {
      this.parseResponse(data)
    } else {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cashbox/CashTable.vue